import * as Yup from 'yup';
import { Team, PrettifyType, TeamAthlete } from '@type/db-types';

interface TeamFormPure
    extends Omit<Team, 'id' | 'description' | 'createdAt' | 'createdByUserId' | 'updatedAt'>,
        Partial<Pick<Team, 'id' | 'createdAt' | 'createdByUserId' | 'updatedAt'>> {
    stripeDetailsSubmitted: boolean;
}

export type TeamForm = PrettifyType<TeamFormPure>;

export const getDefaultNewTeam = (
    existingTeam: TeamAthlete | undefined,
    stripeDetailsSubmitted: boolean | undefined,
    userId: string | undefined,
): TeamForm => {
    return {
        codeOfConduct: existingTeam?.codeOfConduct || '',
        createdAt: existingTeam?.teamCreatedAt || '',
        // description: existingTeam?.description || '',
        id: existingTeam?.id || '',
        fee: existingTeam?.fee || 0,
        imageUrl: existingTeam?.teamImageUrl || '',
        name: existingTeam?.name || '',
        payToUserId: existingTeam?.teamPayToUserId || userId || '',
        stripeDetailsSubmitted: !!stripeDetailsSubmitted,
    };
};

export const newTeamSchema: Yup.ObjectSchema<TeamForm> = Yup.object({
    codeOfConduct: Yup.string().required(),
    createdAt: Yup.string().optional(),
    createdByUserId: Yup.string().optional(),
    // description: Yup.string().required(),
    fee: Yup.number().required(),
    id: Yup.string().optional(),
    imageUrl: Yup.string().ensure(),
    name: Yup.string().required(),
    payToUserId: Yup.string().ensure(),
    stripeDetailsSubmitted: Yup.boolean().required(),
    updatedAt: Yup.string().optional(),
});
